export function popups() {
    const $body = $("body");
    const $popupInfo = $(".popup-info");

    function openPopup($hrefPopup, $videoSrc) {
        $body.addClass("popup-open");
        $($hrefPopup).fadeIn(300);
        if ($($hrefPopup).hasClass("video-popup")) {
            const $videoHolder = $($hrefPopup).find(".video-popup-holder");
            insertVideo($videoHolder, $videoSrc);
        }
    }

    function closePopup() {
        $body.removeClass("popup-open");
        $popupInfo.fadeOut(200);
        $popupInfo.find("video").remove();
        $popupInfo.find("iframe").remove();
    }

    $(document).on("keydown", function (event) {
        if (event.keyCode == 27) {
            closePopup();
        }
    });

    $body.on("click", ".popup-opener", function (e) {
        const $hrefPopup = $(this).attr("href");
        const $videoSrc = $(this).data("src");
        openPopup($hrefPopup, $videoSrc);
        e.preventDefault();
    });

    $body.on("click", ".popup-holder", function (e) {
        if (!(e.target != this)) {
            closePopup();
        }
    });

    $body.on("click", ".popup-close", function (e) {
        e.preventDefault();
        closePopup();
    });


    function insertVideo(element, videoSrc) {
        const isEmbed = videoSrc.indexOf("embed") !== -1;
        const video = isEmbed
            ? `<iframe width="100%" height="100vh" src="${videoSrc}?rel=0&modestbranding=1&autoplay=1&mute=0&showinfo=0autohide=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
            : `<video controls autoplay playsinline>
                 <source src='${videoSrc}' type='video/mp4'>
               </video>`;

        $(element).append(video);
    }
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js